import handleForbidden from './handleForbidden';
import isNotAuthorizedOnError from './isNotAuthorizedOnError';

export default function interceptors(dispatch: any, error: any) {
  handleForbidden(dispatch, error);
  isNotAuthorizedOnError(dispatch, error);
}
